<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-card>
          <div class="md-card-content">
            <md-content v-html="$Region.mission.description" />
          </div>
        </md-card>
      </div>
      <div class="md-layout-item md-size-100">
        <dashboard-achievements
          :teacher="USER_DATA.teacher"
          :usertype="USER_DATA.usertype"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { types } from "@/store/types";
import DashboardAchievements from "@/pages/Dashboard/Components/DashboardAchievements";
export default {
  name: "Mission",

  components: {
    DashboardAchievements
  },
  props: {},
  data() {
    return {
    };
  },

  computed: {
    ...mapGetters([
      types.getters.USER_DATA
    ])
  },
};
</script>

<style scoped>
</style>
